export default __webpack_public_path__ + "static/media/A5.33dea921.mp3";